import { NonIdealState } from "@blueprintjs/core";
import { FilePondFile } from "filepond";
import {
  FGCustomInput,
  FGCustomPanel,
  FGDateMaskInput,
  FGSelectInput,
  FGTextInput,
  FieldGroup,
  FieldSet,
} from "nsitools-react";
import * as React from "react";
import { FilePond } from "react-filepond";

import { useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { CompetitionJudgeSelection } from "../../../../../pages/request/competitionRequest/item/CompetitionJudgeSelection";
import { DrupalCompetitionClubAddress } from "./DrupalCompetitionClubAddress";
import { FGSRSHDateMaskInput } from "../../../../../components";

export interface IDrupalCompetitionDateSelectionProps {
  activities: any;
  aloading: boolean;
  postCodes: any;
  ploading: boolean;
  subActivities: any;
  saloading: boolean;
  sections: any;
  sloading: boolean;
  formik: any;
  onFileUpload: (f: FilePondFile) => void;
}

export const DrupalCompetitionDateSelection: React.FunctionComponent<IDrupalCompetitionDateSelectionProps> = ({
  activities,
  aloading,
  postCodes,
  ploading,
  subActivities,
  saloading,
  sections,
  sloading,
  formik,
  onFileUpload,
}) => {
  const { t } = useTl();
  return (
    <>
      <FieldGroup columns={2}>
        <div>
          <FGSRSHDateMaskInput name="dateFrom" label={t(ETLCodes.DateFrom)} requiredMark />
          <FGSRSHDateMaskInput name="dateTo" label={t(ETLCodes.DateTo)} requiredMark />
        </div>
        <div>
          <FGSelectInput
            name="sectionId"
            label={t(ETLCodes.Section)}
            items={sections}
            loading={sloading}
            requiredMark
          />{" "}
          <FGSelectInput
            name="activityId"
            label={t(ETLCodes.Activity)}
            items={activities}
            loading={aloading}
            requiredMark
          />{" "}
          <FGSelectInput
            name="subActivityId"
            label={t(ETLCodes.SubActivity)}
            items={subActivities}
            loading={saloading}
            requiredMark
          />
          <FGTextInput name="extra" label={t(ETLCodes.Extra)} />
        </div>
      </FieldGroup>
      <DrupalCompetitionClubAddress postCodes={postCodes} ploading={ploading} />
      <FGCustomInput name="files" label={t(ETLCodes.CompetitionFile)}>
        {(ctx) => (
          <FilePond
            labelIdle={t(ETLCodes.FilePondDragOrSelect)}
            onupdatefiles={(f) => {
              ctx.formik.setFieldValue("files", f.length > 0 ? f[0] : null);
              console.log("file", f.length > 0 ? f[0] : null);
              onFileUpload(f.length > 0 ? f[0] : null);
            }}
            allowMultiple={false}
          />
        )}
      </FGCustomInput>
      <FieldSet title={t(ETLCodes.Judges)}>
        <FGCustomPanel>
          {({ formik }) =>
            formik?.values?.subActivityId ? (
              <>
                <CompetitionJudgeSelection
                  linkedIds={formik?.values?.judgeIds || null}
                  onLinkedIdsChanged={(ids) => {
                    formik?.setFieldValue("judgeIds", ids);
                  }}
                  editMode={true}
                  loading={sloading}
                />
              </>
            ) : (
              <NonIdealState icon="resolve" description={t(ETLCodes.PleaseSelectSubActivityToViewPossibleJudges)} />
            )
          }
        </FGCustomPanel>
      </FieldSet>
    </>
  );
};
